import { render, staticRenderFns } from "./VideoPlayer.Chunked.vue?vue&type=template&id=de9a07ce&scoped=true&"
import script from "./VideoPlayer.Chunked.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.Chunked.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.Chunked.vue?vue&type=style&index=0&id=de9a07ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9a07ce",
  null
  
)

export default component.exports